import EventBus from "./event-bus";
import { EVENTS, base_url } from './constants';
import DataStore from './data-store';
import UserService from './user-service';
import UrlService from './url-service';
import moment, { Moment } from 'moment';
import _ from 'lodash';
import { Order, SaleArea, Shop } from "../../types";
import growl from "./growl";

let factory = {
		// shop = currentShop || lastShop
		// if shop is NULL, it means it's in the process of being fetched from the server
		// in that case, wait for the 'shopChanged' event
		// or use qShop, which will return the shop
		prix,
		hasSaleArea,
		shop: null,
		qShop: null,
		currentShop: null,
		lastShop: null,
		weekdays: ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'],
		localWeekdays: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
		openHoursAfter,
		openDateAfter,
		getOpeningMomentBefore,
		isOpenAtPickup,
		setShopIdAsync,
		getItem,
		getItemFromPid,
		mergeWorktimes,
		getMergedOpenHours,
		isAreaEnabled,
		isOpen,
		getShopPayload,
		updateShopWithProductsAsync,
		SALE_MODES: {
			KIOSK: 1,
			A_TABLE: 2,
			BORNE: 3,
			CLIENT: 4,
		},
		SALE_AREAS: {
			RESTAURANT: 1,
			TO_STAY: 2,
			TO_GO: 3,
			DELIVERY: 4,
			TICKET: 5,
		},
		CONFIRM_ORDER_METHODS: {
			NONE: 0,
			CONFIRM_ONLY: 1,
			BY_CREDIT_CARD: 2,
			BY_FIDELITE_CARD: 4,
			BY_PAY_GREEN: 8,
			BY_COMO: 16,
			BY_EDENRED: 32,
		},
		// taken from https://en.wikipedia.org/wiki/ISO_4217, as requested by google Payments
		// loaded using getCurrencies() in init() method
		CURRENCIES: {},
		// CURRENCIES: {
		// 	EUR: '€',
		// 	USD: '$',
		// 	XAF: 'FCFA',
		// 	CHF: 'CHF',
		// 	MUR: 'Rs',
		// },
		saveShop,
		isInDarkKitchenGroup,
		setConfirmMethod,
		getConfirmMethod,
	}

	init();

	function init() {
		getCurrencies();
		if (!isAdminApp()) {
			injectShopIdIntoPath();
		}
		// new Promise((resolve)=>resolve('ok'))
		// .then(() => loadShopFromPathOrUsersProfile())
		setTimeout(_ => loadShopFromPathOrUsersProfile());
		// $rootScope.$on('$stateChangeSuccess', (ev,a,b,c,d) => loadShopFromPathOrUsersProfile())
		EventBus.$on(EVENTS.login, _ => loadShopFromPathOrUsersProfile())
	}

	function setConfirmMethod(confirmMethod, active) {
		let confirmOrderMethods = factory.shop.confirmOrderMethods;
		let offset = Math.log(confirmMethod) / Math.log(2);
		// clearing mask
		let mask = ~(1 << offset);
		// clear
		confirmOrderMethods = confirmOrderMethods & mask;
		// set to active
		confirmOrderMethods = confirmOrderMethods | (active << offset);

					// this.confirmMethods.confirm * 1 +
					// this.confirmMethods.payCard * 2 +
					// this.confirmMethods.payFidelite * 4 +
					// this.confirmMethods.payPaygreen * 8 +
					// this.confirmMethods.payComo * 16 +
					// this.confirmMethods.payEdenred * 32;

		factory.shop.confirmOrderMethods = confirmOrderMethods;
	}

	function getConfirmMethod(confirmMethod) {
		let confirmOrderMethods = factory.shop.confirmOrderMethods;
		let offset = Math.log(confirmMethod) / Math.log(2);
		// mask clearing other bits
		let mask = (1 << offset);
		// clear the rest
		confirmOrderMethods = confirmOrderMethods & mask;
		return confirmOrderMethods != 0;
	}

	function isInDarkKitchenGroup(shop: Shop) {
		let GroupId = shop.GroupId;
		let masterShop = shop.sister_shops.find(sister => sister.ShopId == GroupId);
		return masterShop?.info.dark_kitchen;
	}

	function saveShop() {
		let shop = getShopPayload(factory.shop);
		let payload = {
			ShopId: shop.ShopId,
			shop: shop,
		};
		return DataStore.post(base_url + '/admin/user/save-profile',payload,'Erreur de mise à jour')
		.then(data => factory.shop.ShopId == data.shop.ShopId && _.assign(factory.shop, DataStore.normalizeShopData(data.shop)))
		.catch(err => {growl.error('Erreur de sauvegarde'); return Promise.reject(err)});
	}


	function prix(p, def = undefined, currency = factory.shop?.Currency || '€', decimals = factory.shop?.CurrencyDecimals || 2) {
		if (!p) return;
		def = def != undefined ? def : "0 " + currency;
		return (+p && numberWithSpaces((_.round(+p,decimals)).toFixed(decimals)).replace(".", ",") + " " + currency) || def;
	}

	function numberWithSpaces(x) {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
	}

	function hasSaleArea(shop: Shop, SaleModeId: number, SaleAreaId: number): boolean {
		return _.some(shop && shop.sale_areas,(area: SaleArea)=> area.pivot.ModeId == SaleModeId && area.SaleAreaId == SaleAreaId);
	}

	function isAdminApp() {
		let path = location.pathname;
		if (!path.endsWith('/')) {
			path = path + '/';
		}
		let search = ['/admin/', '/admin-login/', '/admin1/', '/admin2/','/manager/','/manager-login/'];
		for(let i in search) {
			if (path.indexOf(search[i]) != -1) {
				return true;
			}
		}
		return false;
	}

	function updateShopWithProductsAsync(shop: Shop) : Promise<Shop> {
		return DataStore.getShopInfo(shop.ShopId,shop.CarteId)
		.then(shop => {
			let index = _.findIndex(factory.shop.sister_shops,sister => sister.ShopId == shop.ShopId);
			if (index == -1) {
				return Promise.reject('Magasin associé '+shop.ShopId+' non trouvé dans la liste actuelle '+factory.shop.ShopId);
			}
			factory.shop.sister_shops[index] = shop;
			shop.sister_shops = factory.shop.sister_shops;
			return shop;
		})
	}

	function getShopPayload(shop) {
		shop.Currency = factory.CURRENCIES[shop.CurrencyCode];
		let payload = _.omit(shop, ['optionGroups','productTree','products','finalProducts','menus','stuart_account','sister_shops','canOrder','Fax']);
		payload.MaxNumberCommands = payload.MaxNumberCommands || -1;
		return payload;
	}

	function isOpen(shop = factory.shop) {
		if (!shop) {
			return null;
		}
		if (shop.closed) {
			return false;
		}
		let areas = [
		factory.SALE_AREAS.RESTAURANT,
		factory.SALE_AREAS.TO_STAY,
		factory.SALE_AREAS.TO_GO,
		factory.SALE_AREAS.DELIVERY,
		];
		let testOrder = {
			shop: shop,
			SaleModeId: factory.SALE_MODES.CLIENT,
			SaleAreaId: areas[0],
		};
		for(let i in areas) {
			testOrder.SaleAreaId = areas[i];
			let isOpen = !!getOpeningMomentBefore(testOrder,moment());
			if (isOpen) {
				return true;
			}
		}
		return false;
	}

	function getCurrencies() {
		DataStore.get(base_url + '/admin/shop/currencies','').then((data) => {
			factory.CURRENCIES = _.mapValues(_.keyBy(data.currencies,'CurrencyCode'),(currencyObj) => currencyObj.CurrencyName);
		})
	}

	function injectShopIdIntoPath() {
		var ShopId = getShopIdFromCookie();
		var path = UrlService.path();
		// inject onlky if path doesn't start with a number already
		if (ShopId && path.search(/^\/\d+/) == -1) {
			UrlService.path('/' + ShopId + path);
			setShopIdAsync(ShopId);
		}
	}

	function getShopIdFromCookie() {
		var cookies = document.cookie.split(';');
		for (var i in cookies) {
			var cookie = cookies[i].split('=');
			var name = cookie[0].trim();
			if (name == 'ShopId') {
				return cookie[1];
			}
		}
		return null;
	}

	function loadShopFromPathOrUsersProfile() {
		var shopIdMatch = UrlService.path().match(/^\/(\d+)\//)
		if (shopIdMatch) {
			var ShopId = shopIdMatch[1]
			setShopIdAsync(ShopId);
		} else if (UrlService.includes('manager') || UrlService.includes('admin2') || UrlService.includes('admin1')) {
			UserService.identity()
			.then((identity) => setShopIdAsync(identity && identity.ShopId));
		} else {
			setShopIdAsync(null);
		}
	}

	// called (internally) whenever getting the new shop will take time
	var qShopId;

	function invalidateShop(qShop, ShopId) {
		factory.lastShop = factory.shop || factory.lastShop;
		factory.shop = null;
		factory.qShop = qShop;
		qShopId = ShopId;
	}

	function setShopIdAsync(ShopId) {
		// console.log('setShopIdAsync(ShopId)',ShopId)
		if (factory.shop && factory.shop.ShopId == ShopId) {
			// same shop
			return Promise.resolve(factory.shop);
		} else if (!ShopId) {
			// no shop : keep the last one
			factory.lastShop = factory.shop || factory.lastShop;
			factory.currentShop = null;
			factory.shop = factory.currentShop || factory.lastShop;
			return Promise.resolve(factory.shop)
		} else if (factory.qShop && qShopId == ShopId) {
			// fetching alreday in progress
			return factory.qShop;
		}

		var qShop = DataStore.getShopInfo(ShopId)
		.then(function(shop) {
				factory.lastShop = factory.shop || factory.lastShop; // keep lastShop if shop is null
				factory.currentShop = shop;
				// console.log('set ShopService.shop to',shop);
				factory.shop = factory.currentShop || factory.lastShop;
				EventBus.$emit(EVENTS.shopChanged, shop);
				if (shop && UrlService.params.ShopId && UrlService.params.ShopId != shop.ShopId) {
					let route = UrlService.current();
					route.params.ShopId = shop.ShopId;
					setTimeout(_ => UrlService.go(route))
				}
				return shop;
			})
		.catch((err) => {
			EventBus.$emit(EVENTS.shopLoadError,ShopId);
		})
		invalidateShop(qShop, ShopId)

		return qShop;
	}
	function getItemFromPid(pid, treeItem) {
		if (treeItem.product.id == pid) {
			return treeItem;
		}
		for(let i in treeItem.childs) {
			let item = getItemFromPid(pid, treeItem.childs[i]);
			if (item) {
				return item;
			}
		}
		return null;
	}

	function getItem(tid, root) {
		if (!root) return null;
		if (root.tid == tid) {
			return root
		}
		for (var i in root.childs) {
			var item = getItem(tid, root.childs[i])
			if (item) {
				return item
			}
		}
		return null
	}

	function openIntervals(order: Order, le_moment: Moment) {
		var startStops = openHours(order.shop, order.SaleModeId, order.SaleAreaId, le_moment);
		// generate intervals
		var interval = moment.duration(order.shop.DeliveryTimeSlot || 30, 'minutes')
		var hours: Moment[] = []
		for (let i in startStops) {
			var openMoment: Moment = startStops[i].open_hour
			var closeMoment: Moment = startStops[i].close_hour
			// round off seconds and millis; needed to compare with time variable
			openMoment.startOf('minute');
			closeMoment.startOf('minute');
			// start by taking the starting hour
			var time = moment(openMoment).startOf('hour')
				// skip time before opening
				while (time.isBefore(openMoment)) {
					time.add(interval)
				}
				while (time.isBefore(closeMoment)) {
					hours.push(moment(time))
					time.add(interval)
				}
			}

			hours.sort((a,b) => a.diff(b));
			hours = _.uniqWith(hours,(a,b)=>a.isSame(b));

			return hours;
		}

		function getMomentFromTimeString(momentDate,hourString) {
			let parsedMoment = moment(hourString,'HH:mm:ss');
			let m = moment(momentDate)
			.hour(parsedMoment.hour())
			.minute(parsedMoment.minute())
			.second(parsedMoment.second());
			return m;
		}

		function openHours(shop: Shop, SaleModeId: number, SaleAreaId: number, atMoment: Moment, includeInactiveAreas = false) {
			if (!moment.isMoment(atMoment)) {
				throw new Error(atMoment + 'is not a momentjs instance');
			}
			var sale_areas = _(shop.sale_areas)
			.pickBy((sale_area) => sale_area.pivot.ModeId == SaleModeId)
			.keyBy('SaleAreaId') // index by its id
			.value();
			let startStops: StartStop[] = [];
			// need to to get array of start - stop times
			for (var i in shop.worktimes) {
				var w = shop.worktimes[i]
				// not the same SaleArea ?
				if (w.SaleAreaId != SaleAreaId) continue;
			// salearea not active ?
			if (!includeInactiveAreas && !sale_areas[w.SaleAreaId]) continue;
			pushHours(moment(atMoment), w, startStops);
		}

		return _.sortBy(startStops, 'open_hour');
	}

	function pushHours(atMoment: Moment, worktime: Worktime, startStops: StartStop[]) {
		let open = getMomentFromTimeString(atMoment,worktime.open_hour);
		let close = getMomentFromTimeString(atMoment,worktime.close_hour);
		if (close.isBefore(open)) {
			// if close is before open, it means closing next day
			close.add(1,'days');
		} else {
			// not sure about this
			// atMoment is after closing,
			// so i move the open/close times to yesterday ???
			if (moment(close).subtract(1,'day').isAfter(atMoment)) {
				open.subtract(1,'day');
				close.subtract(1,'day');
			}
		}
		if (!isWorktimeOpenForDay(worktime, open)) {
			return;
		}
		let in24hours = moment(atMoment).add(24,'hours');
		if (close.isAfter(atMoment) && open.isSameOrBefore(in24hours)) {
			startStops.push({
				open_hour: open,
				close_hour: close,
			})
		}
	}

	function isWorktimeOpenForDay(worktime, m) {
		var dayname = factory.weekdays[m.day()]
		return worktime[dayname] != 0;
	}

	function getOpeningMomentBefore(order: Order, maxMoment: Moment) {
		var now = moment()
		var startStops = openHours(order.shop, order.SaleModeId, order.SaleAreaId, now);
		for (var i in startStops) {
			if (now.isSameOrAfter(startStops[i].open_hour) && now.isBefore(startStops[i].close_hour)) {
				return now;
			}
		}

		for (i in startStops) {
			let openMoment = startStops[i].open_hour;
			if (maxMoment.isSameOrAfter(openMoment) && maxMoment.isBefore(startStops[i].close_hour)) {
				return openMoment;
			}
		}
		return null;
	}

	function openHoursAfter(order: Order, timeToTest: Moment) {
		var hours = openIntervals(order, moment(timeToTest));
		// skip all hours before moment
		while (hours.length && hours[0].isBefore(timeToTest)) {
			hours.shift();
		}
		return hours;
	}

	function openDateAfter(order: Order, mmt: Moment) {
		for (var i = 1; i <= 7; i++) {
			let startOfDay = moment(mmt).hours(0).minutes(0).seconds(0).add(i,'days');
			var intervals = openIntervals(order, startOfDay);
			if (intervals.length != 0) {
				return startOfDay;
			}
		}
		return null;
	}

	function isOpenAtPickup(order) {
		var timeToCheck = moment(order.PickupTimeDate,'YYYY-MM-DD HH:mm:ss');
		var startStops = openHours(order.shop, order.SaleModeId, order.SaleAreaId, timeToCheck);
		for (var i in startStops) {
			let open = startStops[i].open_hour;
			let close = startStops[i].close_hour;
			if (open.isSameOrBefore(timeToCheck) && close.isAfter(timeToCheck)) {
				return true;
			}
		}
		return false;
	}

	function mergeWorktimes(worktimes) {
		var merged = [];
		while (worktimes.length) {
			var w = worktimes.shift();
			// removed other worktimes that can be merged with w
			worktimes = _.reduce(worktimes, function(mergedWorktimes, w_to_merge) {
				if (!wasMerged(w, w_to_merge)) {
					mergedWorktimes.push(w_to_merge)
				}
				return mergedWorktimes;
			}.bind(this), [])
			merged.push(w);
		}
		return merged;
	}

	function wasMerged(worktime, to_be_merged) {
		if (worktime.open_hour.isAfter(to_be_merged.close_hour) || // tobemerged ends too early
			worktime.close_hour.isBefore(to_be_merged.open_hour))  { // to_be_merged starts too late
			return false;
	}
		// do the merge
		if (to_be_merged.open_hour.isBefore(worktime.open_hour)) {
			worktime.open_hour = to_be_merged.open_hour
		}
		if (to_be_merged.close_hour.isAfter(worktime.close_hour)) {
			worktime.close_hour = to_be_merged.close_hour
		}
		return true;
	}

	function getMergedOpenHours(shop) {
		var other_areas_worktimes = {}
		let m = moment().startOf('day');
		for (var dow = 0; dow < 7; dow++) {
			m.day(dow);
			var worktimes = [];
			for (let i in factory.SALE_AREAS) {
				let SaleAreaId = factory.SALE_AREAS[i];
				if (SaleAreaId == factory.SALE_AREAS.DELIVERY) continue;
				let hours = openHours(shop, factory.SALE_MODES.CLIENT, SaleAreaId, m);
				worktimes = worktimes.concat(hours);
			}
			other_areas_worktimes[dow] = mergeWorktimes(worktimes);
		}

		var delivery_worktimes = {}
		for (var dow = 0; dow < 7; dow++) {
			m.day(dow);
			delivery_worktimes[dow] = openHours(shop, factory.SALE_MODES.CLIENT, factory.SALE_AREAS.DELIVERY, m);
		}

		return {
			0: other_areas_worktimes,
			4: delivery_worktimes,
		};
	}

	function isAreaEnabled(shop, area_id) {
		let activeAreas = _(shop.sale_areas).pickBy({
			pivot: {
				ModeId: factory.SALE_MODES.CLIENT
			}
		});
		let active = activeAreas.some({
			SaleAreaId: area_id
		})
		return active;
	}

export default factory;